//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
import { NONE_DISPLAY } from './constants'
//Types
import { EngineLocations, UIDepartment, UIDepartments } from './types';
import { ActionGetLMDepartmentsAPISuccess, ActionGetLMDepartmentsAPI, ActionPostListing, ActionPostListingSuccess, ActionEditLMDepartments, ActionGetEngineLocationsAPISuccess } from './actions';

export interface DealerDepartmentsState {
    departments?: UIDepartments
    engineLocations?: EngineLocations

    liveDepartments?: UIDepartment[]

}

const defaultState: DealerDepartmentsState = {
};

type GetLMDepartmentsAction = ActionGetLMDepartmentsAPISuccess | ActionPostListingSuccess | ActionGetEngineLocationsAPISuccess | ActionEditLMDepartments

function dealerdepartmentsReducer(state: DealerDepartmentsState = defaultState, action: GetLMDepartmentsAction): DealerDepartmentsState {
    switch (action.type) {
        case ACTIONS.GET_LMDEPARTMENTS_API_SUCCESS:
            {
                const originaldepartments = (action as ActionGetLMDepartmentsAPISuccess).departments
                return {
                    ...state,
                    departments: { ...originaldepartments },
                }

            }
        case ACTIONS.POST_ENGINELOCATIONS_API_SUCCESS:
            {
                // const newdepartmentsSaved = (action as ActionPostLMDepartmentsAPISuccess).dep
                return {
                    ...state,
                    // departments: { ...newdepartmentsSaved },
                }
            }
        case ACTIONS.EDIT_LIVE_DEPARTMENTS:
            {
                const changedDepartments = (action as ActionEditLMDepartments).departments
                return {
                    ...state,
                    liveDepartments: [...changedDepartments],

                }
            }
        case ACTIONS.GET_ENGINELOCATIONS_API_SUCCESS:
            {
                const locations = (action as ActionGetEngineLocationsAPISuccess).engineLocations
                return {
                    ...state,
                    engineLocations: { ...locations },
                }                
            }
        case ACTIONS.POST_LISTINGS_API_SUCCESS:
            {
                const changedDepartments = (action as ActionPostListingSuccess).departments
                return {
                    ...state,
                    liveDepartments: [...changedDepartments],

                }
            }

        default: {
            return {
                ...state
            }
        }
    }

}


export default dealerdepartmentsReducer